export default async ()=> {
    const res = await fetch('/sectionData/management_group.json')
    const data = await res.json()
    return data
}